import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
//@mui
import { Box } from '@mui/material';
//components
import CostSummary from '../../../components/projectmng/costcalc/CostSummary';
import CostCalcLockList from '../../../components/projectmng/costcalc/CostCalcLockList';
import { useEffect } from 'react';
import { listProjectCosts } from '../../../modules/projectModule/projectCosts';

const CostCalcListContainer = () => {
  const dispatch = useDispatch();
  const { project, costs } = useSelector(({ projectModule }) => ({
    project: projectModule.project.project,
    costs: projectModule.projectCosts.costs,
  }));

  useEffect(() => {
    if (project) {
      dispatch(listProjectCosts(project.prjUuid));
    }
  }, [project]);

  if (!costs) {
    return null;
  }

  return (
    <Box>
      <Box
        sx={{
          borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          py: 1,
        }}
      >
        <CostSummary project={project} />
      </Box>
      <Box
        sx={{
          py: 1,
        }}
      >
        <CostCalcLockList costs={costs} />
      </Box>
    </Box>
  );
};

export default CostCalcListContainer;
